import { render, staticRenderFns } from "./AddButtonConfig.vue?vue&type=template&id=b197c6ea&scoped=true&"
import script from "./AddButtonConfig.vue?vue&type=script&lang=js&"
export * from "./AddButtonConfig.vue?vue&type=script&lang=js&"
import style0 from "./AddButtonConfig.vue?vue&type=style&index=0&id=b197c6ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b197c6ea",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardActions,VCol,VDialog,VRow,VSelect,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/aims-dashboard/aims-dashboard/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b197c6ea')) {
      api.createRecord('b197c6ea', component.options)
    } else {
      api.reload('b197c6ea', component.options)
    }
    module.hot.accept("./AddButtonConfig.vue?vue&type=template&id=b197c6ea&scoped=true&", function () {
      api.rerender('b197c6ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Multifunction/modal/AddButtonConfig.vue"
export default component.exports